import React, {
  useMemo,
} from 'react'

import AuthenticationContext from './AuthenticationContext'
import useAuthenticationContext from './Authentication.logic/useAuthenticationContext'

const AuthenticationProvider = ({ children }) => {
  // console.log('AuthenticationProvider.js')
  const authenticationContextData = useAuthenticationContext()

  return useMemo(() => (
    <AuthenticationContext.Provider value={authenticationContextData}>
      { children }
    </AuthenticationContext.Provider>
  ), [authenticationContextData]) // eslint-disable-line
}

export default AuthenticationProvider
